import * as React from 'react';
import type {
  RedirectedProductListEntry,
  RedirectedProductIndicators,
} from 'contracts/redirected-products';
import { api, applyQueryString } from 'services/api';
import type { Filters } from 'hooks/store/redirected-products';

type FetchRedirectedProductsResponse = {
  redirectedProducts: RedirectedProductListEntry[];
  indicators: RedirectedProductIndicators;
}

type FetchParams = {
  filters?: Filters;
}

export const useFetchRedirectedProducts = () => {
  const fetchRedirectedProducts = React.useCallback(async (params: FetchParams): Promise<FetchRedirectedProductsResponse> => {
    const filters = params?.filters ?? {};
    const preparedFilters = prepareQueryObject(filters);

    const url = applyQueryString('/inventory/redirected-products', preparedFilters);
    const { data } = await api.get<FetchRedirectedProductsResponse>(url);

    return data;
  }, []);

  return {
    fetchRedirectedProducts,
  };
};

const prepareQueryObject = (filters: Filters) => {
  type MyFilters = Record<string, unknown>;

  if (filters.totalValue) {
    let [from, to] = filters.totalValue.split(':');
    const fromNumber = Number(from);
    const toNumber = Number(to);
    if (!Number.isNaN(fromNumber)) {
      (filters as MyFilters)['totalValueFrom'] = fromNumber;
    }
    if (!Number.isNaN(toNumber)) {
      (filters as MyFilters)['totalValueTo'] = toNumber;
    }
    delete (filters as MyFilters)['totalValue'];
  }

  if (filters.shelfLifeExpirationDate) {
    const rangeValue = filters.shelfLifeExpirationDate;
    if (rangeValue?.startsWith('from')) {
      (filters as MyFilters)['shelfLifeExpirationDateFrom'] = rangeValue.split(':')[1];
    }
    if (rangeValue?.startsWith('to')) {
      (filters as MyFilters)['shelfLifeExpirationDateTo'] = rangeValue.split(':')[1];
    }
    delete (filters as MyFilters)['shelfLifeExpirationDate'];
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (!value || (Array.isArray(value) && !value?.length)) {
      delete (filters as MyFilters)[key];
    }
  });

  return filters;
};